import React from "react";
import "./VehicleSearchDialogsStyles.scss";
import {Dialog} from "@material-ui/core";
import carCrossImage from "../../../../../../images/car_cross.svg"
import {ReactSVG} from "react-svg";
import {Button} from "../../../../../../components/Button";
import {strings} from "../../../../../../strings/strings";
import {format} from "../../../../../../utils/format";

interface VehicleSearchNotFoundDialog {
    notFoundPlateNumber: string;
    open: boolean;
    onClose: (event: any) => void;
    toManualInputListener: () => void;
}

export const VehicleSearchNotFoundDialog = (props: VehicleSearchNotFoundDialog) => {
    const {open, onClose, notFoundPlateNumber, toManualInputListener} = props;

    return (
        <Dialog open={open} onClose={onClose} disableBackdropClick={true}>
            <div className={"vs-dialog vs-dialog_not-found"}>
                <div className={"vs-dialog__content fluid"}>
                    <div className={"vs-dialog__content__icon"}>
                        <ReactSVG src={carCrossImage}/>
                    </div>

                    <span className={"vs-dialog__content__title"}>{strings.vehicleNotFound}</span>
                    <span className={"vs-dialog__content__title"}>{format(notFoundPlateNumber, '## #### ##')}</span>

                    <p className={"vs-dialog__content__text"}>
                        {strings.vehicleNotFound1}<span
                        className="vs-dialog__content__text_accent">{strings.vehicleNotFound2}</span>
                    </p>

                    <div className={"vs-dialog__content__controls vs-dialog__content__controls_two"}>
                        <Button id={'vehicleNotFound1_changeNumber'} variant={'outlined'}
                                label={strings.vehicleNotFoundChangeNumber} onClickListener={() => onClose(undefined)}/>
                        <Button id={'vehicleNotFound1_toolbarManual'} label={strings.toolbarManual}
                                onClickListener={toManualInputListener}/>
                    </div>
                </div>
            </div>
        </Dialog>
    )
};
